(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 1752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2156)


/***/ }),

/***/ 5820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);




var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces;
var StyledBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerContainer",
  componentId: "sc-13zc8xh-0"
})(["display:flex;justify-content:space-between;flex-direction:column;position:relative;align-items:center;max-width:", "px;padding-top:", "px;padding-bottom:", "px;@media ", "{padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;}"], spaces.large24X * 10 + 80, spaces.large12X - 2, spaces.large24X, devices.tablet, spaces.regular, spaces.regular, spaces.regular, spaces.regular);
var StyledBannerImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerImageContainer",
  componentId: "sc-13zc8xh-1"
})(["", " img{max-width:100%;max-height:100%;}"], function (_ref) {
  var width = _ref.width;
  return width && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["width:", "px;"], width);
});
var StyledBannerContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerContentContainer",
  componentId: "sc-13zc8xh-2"
})(["display:flex;flex-direction:column;justify-content:center;@media ", "{padding-right:0;width:100%;}"], devices.tablet);
var StyledBannerHeaderSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerHeaderSection",
  componentId: "sc-13zc8xh-3"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:500;color:", ";text-align:center;@media ", "{font-size:", "px;margin-bottom:", "px;}"], spaces.large2X - 2, fontSizes.large11X, colors.gray[800], devices.tablet, fontSizes.large2X, spaces.large);
var StyledBannerSubHeaderSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AboutBannerSection__StyledBannerSubHeaderSection",
  componentId: "sc-13zc8xh-4"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";text-align:center;@media ", "{font-size:", "px;margin-bottom:", "px;}"], spaces.large9X, fontSizes.large, colors.gray[700], devices.tablet, fontSizes.regular, spaces.large3X);

var AboutBannerSection = function AboutBannerSection(_ref2) {
  var imgSrc = _ref2.imgSrc,
      header = _ref2.header,
      subHeader = _ref2.subHeader;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledBannerContainer, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledBannerContentContainer, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerHeaderSection, {
        children: header
      }), subHeader && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerSubHeaderSection, {
        children: subHeader
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBannerImageContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
          srcSet: imgSrc,
          type: "image/png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
          src: imgSrc,
          alt: "Banner image"
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AboutBannerSection);

/***/ }),

/***/ 2410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);


var _excluded = ["moreSpace", "imgTopDesktopPosition"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.spaces */ .r.spaces;
var StyledBottomBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BottomBannerSection__StyledBottomBannerContainer",
  componentId: "sc-rgywhc-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;width:100%;margin-bottom:", "px;margin-top:", "px;@media ", "{margin-bottom:", "px;margin-top:", "px;}"], spaces.large24X, spaces.large24X, devices.tablet, spaces.large9X, spaces.large9X);
var StyledDisclaimer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BottomBannerSection__StyledDisclaimer",
  componentId: "sc-rgywhc-1"
})(["max-width:", "px;width:100%;text-align:center;margin-top:", "px;font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";@media ", "{padding-left:", "px;padding-right:", "px;}"], spaces.large24X * 10 + 80, spaces.regular, fontSizes.regular, colors.gray[500], devices.tablet, spaces.regular, spaces.regular); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledBottomBannerSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function (_ref, ref) {
  var moreSpace = _ref.moreSpace,
      imgTopDesktopPosition = _ref.imgTopDesktopPosition,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "BottomBannerSection__StyledBottomBannerSection",
  componentId: "sc-rgywhc-2"
})(["display:flex;justify-content:space-between;background:", ";border-radius:40px;max-width:", "px;width:100%;padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;.header{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;margin-bottom:", "px;margin-right:", "px;}.footer{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";display:flex;flex-direction:row;justify-content:space-between;align-items:center;}.column1{padding-right:", "px;}.column2{margin-top:", ";margin-bottom:-60px;margin-right:-55px;}@media ", "{margin-left:0;margin-right:0;border-radius:0px;box-shadow:0px 30px 80px rgba(0,0,0,0.05);padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;align-items:center;.header{font-size:", "px;line-height:150%;margin-bottom:", "px;margin-right:", "px;}.footer{font-size:", "px;line-height:24px;flex-direction:column;align-items:flex-start;gap:10px;}.column2{margin:0;img{height:120px;}}}"], colors.blue[600], spaces.large24X * 10 + 80, spaces.large14X, spaces.large14X, spaces.large9X, spaces.large9X, fontSizes.large11X, colors.white, function (_ref2) {
  var moreSpace = _ref2.moreSpace;
  return moreSpace ? spaces.large4X : spaces.medium;
}, spaces.large14X, fontSizes.large, colors.blue[100], spaces.regular, function (_ref3) {
  var imgTopDesktopPosition = _ref3.imgTopDesktopPosition;
  return imgTopDesktopPosition || 0;
}, devices.tablet, spaces.regular, spaces.regular, spaces.large, spaces.large, fontSizes.large, function (_ref4) {
  var moreSpace = _ref4.moreSpace;
  return moreSpace ? spaces.regular : spaces.smallX;
}, spaces.smallX, fontSizes.regular);

var BottomBannerSection = function BottomBannerSection(_ref5) {
  var header = _ref5.header,
      footer = _ref5.footer,
      imgSrc = _ref5.imgSrc,
      imgTopDesktopPosition = _ref5.imgTopDesktopPosition,
      moreSpace = _ref5.moreSpace,
      disclaimer = _ref5.disclaimer;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBottomBannerContainer, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBottomBannerSection, {
      imgTopDesktopPosition: imgTopDesktopPosition,
      moreSpace: moreSpace,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "column1",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "header",
          children: header
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "footer",
          children: footer
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "column2",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("picture", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
            srcSet: imgSrc,
            type: "image/png"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: imgSrc,
            alt: "Banner image"
          })]
        })
      })]
    }), disclaimer && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledDisclaimer, {
      children: "All information submitted to Trademark Genius shall be regarded as strictly confidential. Trademark Genius will not reveal any intellectual property information to any organization other than as necessary for submission to the USPTO."
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BottomBannerSection);

/***/ }),

/***/ 4344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Privacy; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./_config/index.js
var _config = __webpack_require__(8002);
// EXTERNAL MODULE: ./_constants/icons.js
var icons = __webpack_require__(934);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./_constants/routes.js
var routes = __webpack_require__(672);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/composed/sections/PrivacySection/index.jsx





var colors = theme/* theme.colors */.r.colors,
    devices = theme/* theme.devices */.r.devices,
    fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    spaces = theme/* theme.spaces */.r.spaces;
var StyledPrivacy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PrivacySection__StyledPrivacy",
  componentId: "sc-v7o67d-0"
})(["max-width:", "px;width:100%;background:", ";box-shadow:0px 30px 80px rgba(0,0,0,0.1);border-radius:30px;padding:", "px;p{font-family:'Aeonik';font-style:normal;text-align:justify;font-size:", "px;color:", ";}h4{color:", ";font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;margin-bottom:", "px;}.tag{border-left:3px solid ", ";margin-top:", "px;margin-bottom:", "px;padding-left:", "px;}@media ", "{padding:", "px;border-radius:0px;box-shadow:unset;}"], spaces.large24X * 10 + 80, colors.white, spaces.large2X - 2, fontSizes.regular, colors.gray[700], colors.blue[500], fontSizes.regular, spaces.smallX, colors.blue[500], spaces.large, spaces.large, spaces.regular, devices.tablet, spaces.regular);

var PrivacySection = function PrivacySection() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPrivacy, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "text",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
        children: ["At TrademarkGenius.com, your privacy is a top priority.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Below contains our privacy policy in detail:"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontWeight: 'bold'
        },
        children: "Your privacy is vital to our long-term relationship with you, and protecting your privacy is just one part of our mission to provide you with highly personalized and valuable service. We will never trade, lease or sell your name or e-mail address information. We will contact you ONLY if your order information is incomplete."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This statement describes our privacy policy with respect to: What Information is Collected; How Information is Collected; and by Whom is Information Collected The Sharing of Collected Information Security of Information TrademarkGenius.com use of \u2018cookies\u2018. Amendments to Our Privacy Policy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What Information is Collected; How Information is Collected; and by Whom is Information Collected Required Personally Identifiable Information To apply for a trademark, you must submit your name, e-mail address. In addition, you must submit other information, including your address, phone number and credit card information. This required personally identifiable information is necessary for us to process transactions for you, protect you against credit card fraud and contact you. When you register with TrademarkGenius.com\u2122, we will ask you for a \u2018e-mail.\u2018"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "We will never share the information stored on that database, as well as other information we collect or you provide with any business partners or third parties, including those who offer services that complement those provided by us or which we believe may be of interest to you."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "tag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
          children: "Transaction Information"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "When you authorize a purchase transaction, we will collect certain information related to that transaction such as the location from which you are requesting the search or transaction, the product or service involved, the quantity or amount of the product or service and certain personally identifiable information, such as your password, your credit card information and any special handling requests. This personally identifiable information will never knowingly appear in public areas of our Web site."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "tag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
          children: "Third Party Information"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "During the processing of your transactions, we collect verification information from our credit card authorization services. Credit card authorization services verify that credit card information and address that they have on file for you matches the information that you have provided to us."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "tag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
          children: "General Information"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "We collect general information about you when you visit our web site. This information includes technical information related to your computer and the manner in which you are accessing our site and includes such information as the internet protocol (IP) address of your computer, what operating system your computer is using, what browser software (e.g., Explorer, Netscape or other) your computer is using, and who your Internet service provider is, the Uniform Resource Locator (\u2018URL\u2018) of the web site from which you just came and the URL to which you go next and certain operating metrics, such as the amount of time you use our Web site. The general information that we gather about you may be aggregated with general information of all users to help us better understand how our site is used. In addition, we aggregate the general information and the personal information. We compile and analyze this aggregated information so that we can provide more meaningful information to corporate partners and more relevant content and advertisements to you."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "tag",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
          children: "The Sharing of Collected Information"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Personally Identifiable Information"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "As noted above, we only share certain information about you with our billing processing agent who is responsible for processing the online billing trasnactions. We will not share your personally identifying information with other third parties without your consent, except for the following limited purposes: We are compelled to do so by law or by an order of a court or governmental authority."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "In order to cooperate with law enforcement authorities or governmental regulatory bodies, and if we find any fraudulant activities."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "As necessary to complete a transaction for you."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "As we deem necessary to protect the rights, safety or property of TrademarkGenius.com, our users or others o r to enforce our terms of use agreement or privacy policy."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "If you use our Web site through a link from one of our promotional partners, then we may be required to share your user registration information or other personally identifying information about any search or transaction that you initiate through such promotional partner with that partner. TrademarkGenius.com and third-party use of \u2018cookies\u2018 and \u2018action tags.\u2018 TrademarkGenius.com Cookies: When you use our site we will store cookies on your computer in order to facilitate and customize your use of our site. A cookie is a small data text file, which a Web site stores on your computer's hard drive (if your Web browser permits) that can later be retrieved to identify you to TrademarkGenius.com. Our cookies store randomly assigned user identification numbers, the country where you are located, and your first name to welcome you back to our site. The cookies make your use of the site easier, allow you to retrieve an earlier shopping cart, make the site run more smoothly and help us to maintain a secure site. You will be unable to shop on our site without your browser set to accept cookies."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Aggregated General Information"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In addition, we may share aggregated general information about our site with our business partners or the general public. For example, we may share information regarding the daily number of unique users to our site with potential corporate partners or others. Aggregated data does not contain any information that could be used to contact or identify you.Third Party SitesWe may publish links to other sites from our web site. Please note that TrademarkGenius.com does not control the content, practices or policies of any other site, including what information those sites collect about you. Accordingly, we do not endorse or hold ourselves responsible for the privacy policies or information gathering practices of any site that you may link to from our site. In addition, you may choose to respond to advertisements that are posted on our web site or made available via our service or to direct marketing offers from third party sponsors or advertisers. We do not control the content, practices or policies of our sponsors or advertisers and, accordingly, do not endorse or hold ourselves responsible for the privacy policies or information gathering practices of any sponsor or advertiser who may collect information about you. Security TrademarkGenius.com uses the highest security standard available (SSL) to encrypt all of your credit card and personally identifiable information while it is in transit to us. All data stored on the TrademarkGenius.com server is protected by a secure \u2018firewall\u2018 so that no unauthorized use or activity can take place. Although TrademarkGenius.com will make every effort to safeguard your personal information from loss, misuse or alteration by third parties, you should be aware that there is always some risk that thieves may find a way to thwart our security system or that transmissions over the Internet will be intercepted."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Amendments to Our Privacy Policy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "We may, from time to time, amend our Privacy Policy. If we do, then we will post such amendments to this document so that you may always have access to our most recent policy. We reserve the right, at our discretion, to change, modify, add or remove portions of our Privacy Policy at any time and from time to time. If at any point we decide to disclose personal information in a manner different from that stated at the time it was collected, we will notify users by email. You will be given t he choice at that time to \u2018opt-out\u2018 of any disclosures of your personal information that you made available to us prior to the change in our policy."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Acknowledgment and Acceptance of our Privacy Policy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This Privacy Statement is incorporated into and subject to the Terms of Use contained on this web site (the \u2018Terms\u2018). As you know, your use of the TrademarkGenius.com web site is subject to the Terms. When you register with us, you affirmatively agree to all terms of the Terms, including this Privacy Policy. Your continued use of this Web site constitutes your continued agreement to the terms of the Terms, including this Privacy Policy. If you do not agree with the terms of our Privacy Policy, you should cease using our Web site."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This Site and Applications are not intended to create any attorney-client relationship, and your use of TrademarkGenius does not and will not create an attorney-client relationship between you and TrademarkGenius. Instead, you are and will be representing yourself in any legal matter you undertake through TrademarkGenius's legal document service."
      })]
    })
  });
};

/* harmony default export */ var sections_PrivacySection = (PrivacySection);
// EXTERNAL MODULE: ./_components/composed/sections/AboutBannerSection/index.jsx
var AboutBannerSection = __webpack_require__(5820);
// EXTERNAL MODULE: ./_components/composed/sections/BottomBannerSection/index.jsx
var BottomBannerSection = __webpack_require__(2410);
// EXTERNAL MODULE: ./_components/atomic/Button/index.jsx
var Button = __webpack_require__(8509);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
;// CONCATENATED MODULE: ./_components/composed/pages/PrivacyPage/index.jsx


var _excluded = ["size", "rotate", "top", "bottom", "left", "right"],
    _excluded2 = ["top", "bottom", "left", "right"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var StyledPrivacyPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PrivacyPage__StyledPrivacyPage",
  componentId: "sc-1jngf0e-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;"]); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledCircle = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var size = _ref.size,
      rotate = _ref.rotate,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "PrivacyPage__StyledCircle",
  componentId: "sc-1jngf0e-1"
})(["position:absolute;background:", ";border-radius:50%;opacity:0.1;z-index:-1;", " ", " ", " ", " ", " ", " @media ", "{display:none;}"], "linear-gradient(180deg, ".concat(theme/* theme.colors.blue.500 */.r.colors.blue[500], " 0%, rgba(46, 144, 250, 0) 100%)"), function (_ref2) {
  var top = _ref2.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref3) {
  var bottom = _ref3.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref4) {
  var left = _ref4.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref5) {
  var right = _ref5.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref6) {
  var rotate = _ref6.rotate;
  return rotate && (0,styled_components_browser_esm/* css */.iv)(["transform:", ";"], "rotate(".concat(rotate, "deg)"));
}, function (_ref7) {
  var size = _ref7.size;
  return size && (0,styled_components_browser_esm/* css */.iv)(["width:", "px;height:", "px;"], size, size);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.devices.tablet;
}); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledImageContainer = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref9, ref) {
  var top = _ref9.top,
      bottom = _ref9.bottom,
      left = _ref9.left,
      right = _ref9.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref9, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "PrivacyPage__StyledImageContainer",
  componentId: "sc-1jngf0e-2"
})(["position:absolute;z-index:-1;", " ", " ", " ", " @media ", "{display:none;}"], function (_ref10) {
  var top = _ref10.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref11) {
  var bottom = _ref11.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref12) {
  var left = _ref12.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref13) {
  var right = _ref13.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.devices.tablet;
});

var PrivacyPage = function PrivacyPage() {
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPrivacyPage, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AboutBannerSection/* default */.Z, {
      header: "Privacy Policy",
      imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/terms.svg")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(sections_PrivacySection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBannerSection/* default */.Z, {
      header: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Don't wait, Protect Your Brand now"
      }),
      footer: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: theme/* theme.colors.blue.500 */.r.colors.blue[500]
        }),
        color: theme/* theme.colors.white */.r.colors.white,
        onClick: function onClick() {
          return router.push(routes/* ROUTES.trademarkRegistration */.Z.trademarkRegistration);
        },
        textColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        hoverColor: theme/* theme.colors.white */.r.colors.white,
        hoverTextColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        children: "Start Registering Now"
      }),
      imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/trademark-registration-bottom.svg"),
      imgTopDesktopPosition: "-130px",
      moreSpace: true,
      disclaimer: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: -90,
      left: -63,
      top: -199
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: -44,
      top: 285,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: -90,
      left: -232,
      top: 'calc(30% - 60px)'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: 65,
      top: 'calc(34% + 30px)',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: 90,
      right: -199,
      top: 155
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      right: -66,
      top: 78,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    })]
  });
};

/* harmony default export */ var pages_PrivacyPage = (PrivacyPage);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/privacy.js





function Privacy() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "Privacy Policy"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(pages_PrivacyPage, {})]
  });
}

/***/ }),

/***/ 3030:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return __webpack_require__(4344);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(3030); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);